import Fetch from '@/utils/Fetch';

const checkboxColumnHeader = 'Customer No';
const checkboxColumn = 'CustomerCode';

const getCustomerList = async (searchPhrase: any, pageSize: any, currentPage: any, sortExpression: any, sortDirection: any, activeFilterIds: any, ancillaryFilters: any, populatedList = false, toast = null) => {    

    let params: Record<string, any> = {
      pageSize,
      pageIndex: currentPage - 1,
      searchPhrase,
      sortExpression:
        sortExpression === checkboxColumnHeader
          ? checkboxColumn
          : sortExpression,
      sortDirection,
      populatedList,
    };

    if (activeFilterIds) {
        params = {...params,
            CustomerGroupIDList: activeFilterIds["CustomerGroups"],
            CustomerStatusIDList: activeFilterIds["CustomerStatuses"],
            CustomerTypeIDList: activeFilterIds["CustomerTypes"],
        };
    }

    if (ancillaryFilters) {
        params = {...params, 
            IncludeClosed: ancillaryFilters["IncludeClosed"],
            ShowArchived: ancillaryFilters["ShowArchived"],
        };
    }

    return await Fetch.post({
        url: '/Customer/GetCustomers',
        params: params,
        toastCtx: toast
    });
};

const getCounts = async (id: any) => {
    let countRequest = await Fetch.get({
        url: `/Customer/GetCounts?id=${id}`
    });

    let result = countRequest.Results;
    let contactCount = result.find((x: any) => x.Key == 'Contacts');
    let locationCount = result.find((x: any) => x.Key == 'Locations');
    let jobCount = result.find((x: any) => x.Key == 'Jobs');
    let quoteCount = result.find((x: any) => x.Key == 'Quotes');
    let invoiceCount = result.find((x: any) => x.Key == 'Invoices');
    let queryCount = result.find((x: any) => x.Key == 'Queries');
    let productCount = result.find((x: any) => x.Key == 'Products');
    let appointmentCount = result.find((x: any) => x.Key == 'Appointments');
    let attachmentCount = result.find((x: any) => x.Key == 'Attachments');
    let communicationCount = result.find((x: any) => x.Key == 'Communication');
    
    return {
        contactCount: contactCount ? contactCount.Value : 0,
        locationCount: locationCount ? locationCount.Value : 0,
        jobCount: jobCount ? jobCount.Value : 0,
        quoteCount: quoteCount ? quoteCount.Value : 0,
        invoiceCount: invoiceCount ? invoiceCount.Value : 0,
        queryCount: queryCount ? queryCount.Value : 0,
        productCount: productCount ? productCount.Value : 0,
        appointmentCount: appointmentCount ? appointmentCount.Value : 0,
        attachmentCount: attachmentCount ? attachmentCount.Value : 0,
        communicationCount: communicationCount ? communicationCount.Value : 0,
    }
};

const getCustomer = async (id: any) => {
  const customer = await Fetch.get({
    url: '/Customer/' + id
  });
  return customer;
};

const archiveCustomer = async (id: any, toast = null) => {
    return await Fetch.put({
        url: '/Customer/Archive?id=' + id,
        toastCtx: toast
    });
};

const archiveSelectedCustomers = async (customerIDs: any, toast = null) => {
    return await Fetch.post({
        url: '/Customer/ArchiveToggle',
        params: customerIDs,
        toastCtx: toast
    });
};

const getCountries = async () => {
    const countries = await Fetch.get({
        url: '/Country'
    });
    return countries.Results;
};

const getCountry = async (id: any) => {
  const country = await Fetch.get({
    url: `/Country/${id}`
  });
  return country;
};

const getCustomerGroups = async () => {
    return await Fetch.get({
        url: '/CustomerGroup'
    });
};

const getCustomerStatuses = async () => {
    return await Fetch.get({
        url: '/CustomerStatus'
    });
};

const getCustomerTypes = async () => {
    return await Fetch.get({
        url: '/CustomerType'
    });
};

const getIndustryTypes = async () => {
    return await Fetch.get({
        url: `/IndustryType`
    });
};

const getMediaTypes = async () => {
    return await Fetch.get({
        url: `/MediaType`
    });
};

const getDesignations = async () => {
  return await Fetch.get({
    url: `/Designation`
  });
};

const contactsFilter = (contacts: any, contactSearch: any) => {
  return contacts.filter((contact: any) => {
    const contactName = contact.FirstName + " " + contact.LastName;
    if (contactName.toLowerCase().includes(contactSearch.toLowerCase())) {
      return true;
    }
    if (contact.EmailAddress && contact.EmailAddress.toLowerCase().includes(contactSearch.toLowerCase())) {
      return true;
    }
    if (contact.MobileNumber && contact.MobileNumber.includes(contactSearch)) {
      return true;
    }
    return false;
  });
};

const locationsFilter = (locations: any, locationSearch: any) => {
  return locations.filter((location: any) => {
    if (location.LocationDisplay.toLowerCase().includes(locationSearch.toLowerCase())) {
      return true;
    }
    if (location.AddressLine1 && location.AddressLine1.toLowerCase().includes(locationSearch.toLowerCase())) {
      return true;
    }
    if (location.AddressLine2 && location.AddressLine2.includes(locationSearch)) {
      return true;
    }
    return false;
  });
};

const hasLocationChanged = (initialLocation: any, updatedLocation: any) => {
  let hasChanged = false;
  if (initialLocation) {
    if (updatedLocation) {
      if (initialLocation.ID != updatedLocation.ID) {
        hasChanged = true;
      }
    } else {
      hasChanged = true;
    }
  } else {
    if (updatedLocation) {
      hasChanged = true;
    }
  }
  return hasChanged;
};

export default {
    getCustomerList,
    getCounts,
    getCustomer,
    archiveCustomer,
    archiveSelectedCustomers,

    getCustomerGroups,
    getCustomerStatuses,
    getCustomerTypes,    
    getIndustryTypes,
    getMediaTypes,
    getDesignations,
    
    contactsFilter,
    locationsFilter,
    hasLocationChanged,
    getCountries,
    getCountry,

    checkboxColumnHeader,
    checkboxColumn,
};
